import React, { useContext } from "react";
import PropTypes from "prop-types";
import { makeStyles, Box, Container, Typography, Button } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { AuthContext } from "src/context/Auth";
import { handleLogout } from "src/utils/authUtils";
import { clearActingAsClient } from "src/utils/actingAs";

// A deliberately minimal header for the CPA portal - it is its own workspace, not another tab
// inside the regular client dashboard, so it does NOT reuse DashboardLayout/TopBar's full nav
// (Portfolio/Wallets/Transactions/Tax Center/...). Just branding, a way back to the regular
// account, and logout.
const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.background.main,
    minHeight: "100dvh",
    width: "100%",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  content: {
    padding: "0 0 24px 0",
  },
}));

const AccountantLayout = ({ children }) => {
  const classes = useStyles();
  const auth = useContext(AuthContext);

  const onLogout = async () => {
    await handleLogout(auth);
  };

  return (
    <div className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h6" style={{ fontWeight: 700 }}>
          BLOCKSTATS <span style={{ color: "#5F51DE" }}>| CPA</span>
        </Typography>
        {auth?.userLoggedIn && (
          <Box display="flex" alignItems="center" style={{ gap: 12 }}>
            <Button
              component={RouterLink}
              to="/secure/portfolio"
              size="small"
              onClick={clearActingAsClient}
              style={{ textTransform: "none", color: "#5F51DE", fontWeight: 600 }}
            >
              Back to my account
            </Button>
            <Button
              onClick={onLogout}
              size="small"
              variant="outlined"
              style={{ textTransform: "none", color: "#444", borderColor: "#999" }}
            >
              Log out
            </Button>
          </Box>
        )}
      </Box>
      <Container maxWidth="lg" className={classes.content}>
        {children}
      </Container>
    </div>
  );
};

AccountantLayout.propTypes = {
  children: PropTypes.node,
};

export default AccountantLayout;
